import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconCloseOutlined: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        d="M20.4905 3.51284C15.8111 -1.16655 8.19472 -1.16655 3.51533 3.51284C1.24862 5.78044 0 8.79467 0 12.0004C0 15.2061 1.24862 18.2203 3.51533 20.4871C5.85549 22.8272 8.92921 23.9968 12.0029 23.9968C15.0766 23.9968 18.1503 22.8272 20.4904 20.4871C25.1698 15.8077 25.1698 8.19312 20.4905 3.51284ZM19.1758 19.1724C15.2207 23.1275 8.78507 23.1275 4.82995 19.1724C2.91472 17.2571 1.85946 14.7097 1.85946 12.0004C1.85946 9.29113 2.91472 6.74364 4.82995 4.82746C8.78507 0.872343 15.2207 0.873281 19.1758 4.82746C23.13 8.78258 23.13 15.2182 19.1758 19.1724Z"
        fill={fill}
      />
      <path
        d="M16.0087 14.5702L13.3766 11.9418L16.0087 9.31348C16.3713 8.9509 16.3713 8.36238 16.0097 7.99882C15.6462 7.63436 15.0576 7.6353 14.6941 7.99788L12.0602 10.6281L9.42625 7.99788C9.06273 7.6353 8.47421 7.63436 8.11069 7.99882C7.7481 8.36233 7.7481 8.95085 8.11162 9.31348L10.7437 11.9418L8.11162 14.5702C7.7481 14.9328 7.7481 15.5213 8.11069 15.8848C8.292 16.067 8.53093 16.1572 8.76896 16.1572C9.00699 16.1572 9.24498 16.0661 9.42629 15.8857L12.0602 13.2555L14.6942 15.8857C14.8755 16.0671 15.1135 16.1572 15.3515 16.1572C15.5895 16.1572 15.8284 16.0661 16.0098 15.8848C16.3723 15.5213 16.3723 14.9328 16.0087 14.5702Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconCloseOutlined;
